import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_FINANCIAL_CATEGORIES](state, data) {
    state.allFinancialCategories = data
  },
}
